import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "../../../components/common/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useSelector } from "react-redux";
import { postRequest } from "../../../config";

const PaymentSuccess = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const user = useSelector((state) => state.user);
    const query = new URLSearchParams(location.search);
    const type = query.get("type");
    const sessionId = query.get("session_id");

    useEffect(() => {
        if (type !== "temp-module" || !sessionId) return;
        (async () => {
            try {
                await postRequest("/modules/complete-temp-module-purchase", { sessionId });
            } catch (e) {
                console.error("complete-temp-module-purchase:", e);
            }
        })();
    }, [type, sessionId]);

    let message = "You have successfully completed the payment!";
    if (type === "upgrade") {
        message = "You have successfully upgraded the subscription.";
    } else if (type === "module" || type === "temp-module") {
        message = "You have successfully purchased an additional Diligentsia module.";
    }

    return (
        <div className="df jcc aic fdc mih80vh p2rem">
            <div className="df fdc aic g1rem bg-white p2rem br8 sh1 w100% max-w500px tac">
                <h1 className="fs2rem fw600 c15">🎉 Payment Successful!</h1>
                <p className="fs1rem c15">{message}</p>
                <Button
                    onClick={() => navigate(user && user['role'] === "Advisor" ? "/advisor-dashboard" : user && user['role'] === "Investor" ? "/investor-dashboard" : user && user['role'] === "Admin" ? "/admin" : "/dashboard")}
                    prefixIcon={<ArrowBackIcon style={{ fontSize: "1.2rem" }} />}
                    customClassName="df mt2rem"
                    btnType="warning"
                    text={"Go to Dashboard"}
                />
            </div>
        </div>
    );
};

export default PaymentSuccess;
